module.exports = __webpack_public_path__ + "static/img/ZANE-DUURSMA.9c4350e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ZANE-DUURSMA.jpg
// module id = 4rnA
// module chunks = 0